import React, { useState } from "react";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaPaperPlane,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import "../css/contact.css";
import Footer from "./footer";
import Nav from "./nav";
//import contactHeroImage from "../images/contact-hero.jpg"; // Add a high-quality hero image
import Swal from "sweetalert2";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch(
        "https://enerygx-backend.onrender.com/api/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...formData,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Show success alert
        await Swal.fire({
          title: "Success!",
          text: `Thank you for contacting us! We'll get back to you soon.`,
          icon: "success",
          confirmButtonText: "Continue",
          confirmButtonColor: "#0056b3",
        });

        setIsSubmitting(false);
        // Reset form
        setFormData({
          name: "",
          surname: "",
          company: "",
          designation: "",
          email: "",
          telephone: "",
          comment: "",
        });
      } else {
        throw new Error(data.message || "Registration failed");
      }
    } catch (error) {
      // Show error alert
      await Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "Try Again",
        confirmButtonColor: "#d33",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <Nav />

      {/* Enhanced Hero Section */}
      <div className="contact-hero">
        <div className="hero-content">
          <h1> Join the Conversation on a Just Energy Transition!</h1>

          <p className="hero-subtitle">Connect. Collaborate. Transform</p>
          <a href="#form">
            <button className="cta-button">Reach out to us </button>
          </a>

          <div className="scroll-indicator">
            <span></span>
            <div className="scroll-text">SCROLL TO EXPLORE</div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-page">
        <div className="contact-intro">
          <p className="subheading">
            At EnergyX Africa Conference & Exhibition, we are committed to
            driving an equitable and sustainable energy future for Southern
            Africa and the Global South. Your voice matters in shaping the
            transition to cleaner, more inclusive energy systems. Connect with
            us—we’d love to hear from you! Let’s collaborate, innovate, and
            build a just energy future together.
          </p>
        </div>

        {/* Contact Grid */}
        <div className="contact-grid" id="form">
          {/* Contact Information Column */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">
                <FaMapMarkerAlt />
              </div>
              <h3>Our Location</h3>
              <p>
                10 W Circular Rd,
                <br />
                West End, Kimberley, 8301
              </p>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <FaPhone />
              </div>
              <h3>Phone Number</h3>
              <p>+27 69 681 3017 </p>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <FaEnvelope />
              </div>
              <h3>Email Address</h3>
              <p>connect@energyx.africa</p>
            </div>

            <div className="social-media">
              <h3>Follow Us</h3>
              <div className="social-icons">
                <a
                  href="https://www.facebook.com/ExperienceEnergyxAfrica/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook className="icon" />
                </a>
                <a
                  href="https://x.com/EnergyxAfrica"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter className="icon" />
                </a>
                <a
                  href="https://www.instagram.com/energyx.africa/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram className="icon" />
                </a>
                <a
                  href="https://www.linkedin.com/company/experience-energyx-africa/?originalSubdomain=za"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin className="icon" />
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form Column */}
          <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <h2>Send Us a Message</h2>

              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder=" "
                />
                <label htmlFor="name">Your Name</label>
                <div className="underline"></div>
              </div>

              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder=" "
                />
                <label htmlFor="email">Email Address</label>
                <div className="underline"></div>
              </div>

              <div className="form-group">
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder=" "
                  rows="5"
                ></textarea>
                <label htmlFor="message">Your Message</label>
                <div className="underline"></div>
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  "Sending..."
                ) : (
                  <>
                    <FaPaperPlane className="send-icon" /> Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="map-container">
        

        <iframe
         title="Our Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3498.2874554114424!2d24.7536111!3d-28.7408333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9b1a568b03f355%3A0xc570802add5e2cf4!2sMittah%20Seperepere%20Convention%20Centre!5e0!3m2!1sen!2sza!4v1743255977694!5m2!1sen!2sza"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
         
        ></iframe>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
